import React, { useEffect, useRef, useState } from 'react'
import Header from '../../../common/header/Header'
import User_Dashbaord_Common_Section from '../user_dashboard_common_section/User_Dashbaord_Common_Section'
import { Get_Pooja_Invoice_Details, Get_User_Booked_Pooja_List, User_Booked_Pooja_Cancel } from '../../../../api/pooja/Pooja';
import { User_Authentication } from '../../../../user_authentication/User_Authentication';
import Loader from '../../../../loader/Loader';
import { IMG_BASE_URL } from '../../../../config/Config';
import { Link, useNavigate } from 'react-router-dom';
import parse from 'html-react-parser';
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux';
import { fetchSettingData } from '../../../../redux/actions/settingAction';
import { FaFilePdf } from 'react-icons/fa';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const User_Dashboard_My_Pooja_List = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const invoiceRef = useRef(null);
    const [isLoading, setIsLoading] = useState([]);
    const [get_booked_pooja_list, set_User_Booked_Pooja_List] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [customReason, setCustomReason] = useState("");
    const [selectedPoojaId, setSelectedPoojaId] = useState(null);
    const productsPerPage = 4;
    const [package_popup, setPackageDetail] = useState(null)
    const [cancelLoading, setCancelLoading] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isInvoiceOpen, setIsInvoiceOpen] = useState(false);

    const { settingData } = useSelector((state) => state?.settingdata || []);

    // Calculate total pages safely
    const totalPages = Math.ceil(get_booked_pooja_list?.pooja_list?.length / productsPerPage) || 1;

    // Calculate the products to display on the current page
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = get_booked_pooja_list?.pooja_list?.slice(startIndex, startIndex + productsPerPage) || [];

    // Pagination controls
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    const handle_get_user_booked_pooja_list = async () => {
        setIsLoading(true)
        try {
            const token = User_Authentication();
            if (!token) {
                setIsLoading(false);
                throw new Error("User token not found");
            }

            const response = await Get_User_Booked_Pooja_List({ Authorization: `Bearer ${token}` })
            if (response?.data?.status == "200") {
                set_User_Booked_Pooja_List(response?.data?.data)
                setIsLoading(false)
            }
            else if (response?.response?.data?.status == 401) {
                setIsLoading(false)
                localStorage.removeItem("user_token");
                localStorage.removeItem("user_is_active");
                toast("Token Expired. Please Login Again.");
                navigate("/user-login");
                return;
            }
            else if (response?.response?.data?.status == "500") {
                setIsLoading(false)
            }
        }
        catch (error) {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        dispatch(fetchSettingData());
        handle_get_user_booked_pooja_list();
    }, [dispatch])

    const handle_Package_Popup = (package_detail) => {
        setPackageDetail(package_detail)
    }

    const close_Package_Popup = () => {
        setPackageDetail(null);
    };

    const formatTime = (time) => {
        const [hours, minutes] = time.split(":");
        const intHours = parseInt(hours, 10);
        const ampm = intHours >= 12 ? "pm" : "am";
        const formattedHours = intHours % 12 || 12;
        return `${formattedHours}:${minutes} ${ampm}`;
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setCustomReason("");
        setSelectedPoojaId(null);
    }

    const handleCancelPooja = (poojaId) => {
        setSelectedPoojaId(poojaId);
        setIsModalOpen(true);
    }
    const handleConfirmCancelPooja = async () => {
        try {
            setCancelLoading(true);
            const token = User_Authentication();
            if (!token) {
                throw new Error("User token not found");
            }

            const data = {
                booking_id: selectedPoojaId,
                cancel_reason: customReason
            };

            const headers = {
                Authorization: `Bearer ${token}`
            };

            const response = await User_Booked_Pooja_Cancel(data, headers);
            if (response?.status == 200) {
                setIsModalOpen(false);
                setCustomReason("");
                setSelectedPoojaId(null);
                toast.success(response?.message);
                await handle_get_user_booked_pooja_list();
            } else if (response?.status == 500) {
                console.log("error--", response);
                toast.error("Failed to cancel");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else if (response?.status == 401) {
                toast.error("Failed to cancel");
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }
        } catch (error) {
            console.error("Error cancelling order:", error);

        } finally {
            setCancelLoading(false);
        }
    }

    return (
        <div>
            {/* <----------- Header section's ------------> */}
            <Header />
            {
                isLoading ? (
                    <Loader />
                ) : (
                    <section className="gi-faq py-[40px] max-[767px]:py-[30px] gi-wishlist">
                        <div className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1320px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px] pb-5 w-full px-[12px]">
                            <div className="w-full">
                                <div className="w-full my-4 sm:my-10">
                                    <div className="w-full bg-white shadow-xl p-4 sm:p-5">
                                        <div className="my_account w-full flex space-x-2 md:space-x-10">
                                            <User_Dashbaord_Common_Section />
                                            {
                                                currentProduct?.length > 0 ? (
                                                    <div className="flex-1 min-w-0">
                                                        <div className=" w-full">
                                                            <h1 className="font-bold text-[24px] text-qblack mb-4">Book List
                                                            </h1>
                                                            <div
                                                                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-3 md:gap-6">
                                                                {
                                                                    currentProduct?.map((get_booked_pooja_list_result) => {
                                                                        return (
                                                                            <div className="border rounded-lg p-4 bg-white">
                                                                                <div className="flex justify-between items-center">
                                                                                    <div className="flex gap-3 items-center">
                                                                                        <img src={`${IMG_BASE_URL}${get_booked_pooja_list_result?.image}`} className="rounded-md h-16 w-16"
                                                                                            alt="" />
                                                                                        <div>
                                                                                            <h2 className="text-sm font-semibold text-black line-clamp-1">{get_booked_pooja_list_result?.title}</h2>
                                                                                            <p class="text-gray-700 text-xs font-medium clamped-text">
                                                                                                {parse(get_booked_pooja_list_result?.short_description)}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="shadow rounded-md p-4 mt-3">
                                                                                    <div className="grid grid-cols-2 gap-4">
                                                                                        {get_booked_pooja_list_result?.orderNo && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700 block">Order No.</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900 break-all">{get_booked_pooja_list_result?.orderNo}</h5>
                                                                                            </div>
                                                                                        )}

                                                                                        {get_booked_pooja_list_result?.astro?.name && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Pandit Name</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.astro?.name}</h5>
                                                                                            </div>
                                                                                        )}

                                                                                        {get_booked_pooja_list_result?.pooja_date && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Pooja Date</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.pooja_date}</h5>
                                                                                            </div>
                                                                                        )}

                                                                                        {get_booked_pooja_list_result?.from_time && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Pooja Time</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{formatTime(get_booked_pooja_list_result.from_time)}</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.custom_detail && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Additional Info.</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.custom_detail}</h5>
                                                                                            </div>
                                                                                        )}

                                                                                        {get_booked_pooja_list_result?.price && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Amount</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">Rs.{get_booked_pooja_list_result?.price}/-</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.category?.title && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Category</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.category?.title}</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.package_name && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Package Name</span>
                                                                                                <button className="text-[12px] text-gray-900 font-semibold border border-gray-200 hover:text-white hover:bg-red-500 py-1 px-2 rounded" onClick={() => { handle_Package_Popup(get_booked_pooja_list_result?.poojapackage) }}>{get_booked_pooja_list_result?.poojapackage?.name}</button>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.language && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Language</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.language}</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.location && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Location</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.location}</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.poojapackage?.number_of_day && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Days Of Pooja</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.poojapackage?.number_of_day}</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.poojapackage?.number_of_pandit && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Number Of Pandit</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.poojapackage?.number_of_pandit}</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.poojapackage?.duration && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Pooja Duration</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.poojapackage?.duration}</h5>
                                                                                            </div>
                                                                                        )}
                                                                                        {get_booked_pooja_list_result?.paymentmethod && (
                                                                                            <div>
                                                                                                <span className="text-sm text-gray-700">Payment Method</span>
                                                                                                <h5 className="text-xs font-semibold text-gray-900">{get_booked_pooja_list_result?.paymentmethod}</h5>
                                                                                            </div>
                                                                                        )}

                                                                                        <div>
                                                                                            <span className="text-sm text-gray-700">Status</span>
                                                                                            <div className='flex gap-3'>
                                                                                                {
                                                                                                    get_booked_pooja_list_result?.status == "1" ? (
                                                                                                        <h5 className="text-xs text-yellow-500 font-semibold">Pending</h5>
                                                                                                    ) : get_booked_pooja_list_result?.status == "2" ? (
                                                                                                        <h5 className="text-xs text-gray-500 font-semibold">Processing</h5>
                                                                                                    ) : get_booked_pooja_list_result?.status == "3" ? (
                                                                                                        <h5 className="text-xs text-green-700 font-semibold">Complete</h5>
                                                                                                    ) : (
                                                                                                        <h5 className="text-xs text-red-700 font-semibold">Canceled</h5>
                                                                                                    )
                                                                                                }

                                                                                            </div>
                                                                                        </div>
                                                                                        {
                                                                                            get_booked_pooja_list_result?.status == "3" && get_booked_pooja_list_result?.is_review === false && (
                                                                                                <span onClick={() => {
                                                                                                    localStorage.setItem("booking_id", JSON.stringify(get_booked_pooja_list_result?.id));
                                                                                                    localStorage.setItem("astro_user_id", JSON.stringify(get_booked_pooja_list_result?.astro_user_id));
                                                                                                    localStorage.setItem("pooja_id", JSON.stringify(get_booked_pooja_list_result?.pooja_id));
                                                                                                }}
                                                                                                >
                                                                                                    <Link to="/add-pooja-review" className='bg-red-700 text-white px-2 py-1 text-[12px] rounded-sm '>Review</Link>
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                        {
                                                                                            get_booked_pooja_list_result?.id && (
                                                                                                <span onClick={() => {
                                                                                                    localStorage.setItem("booking_id", JSON.stringify(get_booked_pooja_list_result?.id));
                                                                                                    localStorage.setItem("astro_user_id", JSON.stringify(get_booked_pooja_list_result?.astro_user_id));
                                                                                                    localStorage.setItem("pooja_id", JSON.stringify(get_booked_pooja_list_result?.pooja_id));
                                                                                                }}
                                                                                                >
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        onClick={() => {
                                                                                                            setSelectedInvoice(get_booked_pooja_list_result);
                                                                                                            setIsInvoiceOpen(true);
                                                                                                        }}
                                                                                                        className="bg-green-700 text-white px-2 py-1 text-[12px] rounded-sm"
                                                                                                    >
                                                                                                        Invoice
                                                                                                    </button>
                                                                                                </span>
                                                                                            )
                                                                                        }
                                                                                        {get_booked_pooja_list_result?.status == "1" && (
                                                                                            <button type='button'
                                                                                                onClick={() => handleCancelPooja(get_booked_pooja_list_result?.id)} className={`bg-red-600 hover:bg-red-700 px-2 py-1 text-[12px] text-white self-center rounded-sm`} >
                                                                                                Pooja Cancel
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* <!-- Pagination Start --> */}
                                                        <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col">
                                                            <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, get_booked_pooja_list?.pooja_list?.length)} of {get_booked_pooja_list?.pooja_list?.length} Product(s)</span>
                                                            <ul className="gi-pro-pagination-inner flex">
                                                                {currentPage > 1 && (
                                                                    <li>
                                                                        <button
                                                                            onClick={handlePrev}
                                                                            className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                                        >
                                                                            Prev
                                                                        </button>
                                                                    </li>
                                                                )}
                                                                {[...Array(totalPages).keys()].map((page) => (
                                                                    <li key={page} className="inline-block float-left mr-[5px]">
                                                                        <button
                                                                            onClick={() => handlePageChange(page + 1)}
                                                                            className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                    text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                    text-[16px] justify-center items-center rounded-[5px]
                    ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                                        >
                                                                            {page + 1}
                                                                        </button>
                                                                    </li>
                                                                ))}
                                                                {currentPage < totalPages && (
                                                                    <li>
                                                                        <button
                                                                            onClick={handleNext}
                                                                            className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                                        >
                                                                            Next
                                                                        </button>
                                                                    </li>
                                                                )}
                                                            </ul>

                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className='m-auto text-center  '>
                                                        <h4>No bookings Pooja available at the moment</h4>
                                                    </div>
                                                )
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )
            }

            {package_popup && (
                <div className='fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4 backdrop-blur-sm transition-opacity duration-300'>
                    <div className='bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[85vh] transition-all transform scale-100 duration-300'>
                        <div className="relative bg-gradient-to-br from-red-50 to-[#FEE2E2] pt-8 pb-5 px-6 text-center border-b border-red-100/30 shrink-0">
                            <div className="absolute bottom-[-55px] left-0 right-0 z-10 pointer-events-none">
                                <svg className="w-full" height="122" viewBox="0 0 534 122" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 97.5001V0H533.333V97.5001C488.889 65.4241 444.444 65.4241 400 97.5001C355.556 129.576 311.111 129.576 266.667 97.5001C222.222 65.4241 177.778 65.4241 133.333 97.5001C88.8889 129.576 44.4444 129.576 0 97.5001Z" fill="#FEE2E2" />
                                </svg>
                            </div>
                            <button
                                onClick={close_Package_Popup}
                                className="absolute right-4 top-4 z-30 w-8 h-8 flex items-center justify-center bg-white/90 hover:bg-white text-gray-700 hover:text-gray-900 rounded-full shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none"
                            >
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                            <div className="relative z-20">
                                <span className="inline-block px-3 py-1 bg-red-100 text-red-800 text-[11px] font-bold uppercase tracking-wider rounded-full mb-2">Package Details</span>
                                <div className="text-gray-800 font-bold text-lg leading-tight mb-1">{package_popup?.name}</div>
                                <h3 className="text-red-700 font-extrabold text-2xl">₹ {new Intl.NumberFormat('en-IN').format(package_popup?.amount)}</h3>
                            </div>
                        </div>
                        <div className='p-6 pt-16 overflow-y-auto thin-scrollbar flex-1 space-y-5'>
                            <div>
                                <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-3">What's Included</h4>
                                <ul className="space-y-3">
                                    {package_popup?.packages?.length > 0 && package_popup?.packages?.map((list_item, index) => (
                                        <li key={index} className="flex items-start gap-3">
                                            {list_item?.is_included ? (
                                                <div className="flex items-center justify-center shrink-0 w-5 h-5 rounded-full bg-green-50 text-green-600 border border-green-200">
                                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                            ) : (
                                                <div className="flex items-center justify-center shrink-0 w-5 h-5 rounded-full bg-gray-50 text-gray-400 border border-gray-200">
                                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                                    </svg>
                                                </div>
                                            )}
                                            <span className={`text-sm ${list_item?.is_included ? 'text-gray-700 font-medium' : 'text-gray-400 line-through'}`}>
                                                {list_item?.item_name}
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Other Details */}
                            {(package_popup?.number_of_day || package_popup?.number_of_pandit || package_popup?.duration) && (
                                <div className="bg-gray-50 rounded-xl p-4 border border-gray-100 text-sm text-gray-700 space-y-2.5">
                                    {package_popup?.number_of_day && (
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-500 font-medium">Number of Days:</span>
                                            <span className="font-semibold text-gray-900">{package_popup?.number_of_day}</span>
                                        </div>
                                    )}
                                    {package_popup?.number_of_pandit && (
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-500 font-medium">Number of Pandits:</span>
                                            <span className="font-semibold text-gray-900">{package_popup?.number_of_pandit}</span>
                                        </div>
                                    )}
                                    {package_popup?.duration && (
                                        <div className="flex justify-between items-center">
                                            <span className="text-gray-500 font-medium">Duration:</span>
                                            <span className="font-semibold text-gray-900">{package_popup?.duration}</span>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Note Section */}
                            {package_popup?.notes && (
                                <div className="bg-amber-50/70 border border-amber-200/60 rounded-xl p-4">
                                    <div className="flex gap-2">
                                        <svg className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                        </svg>
                                        <p className="text-xs font-semibold text-amber-800 leading-relaxed">
                                            <span className="font-bold uppercase tracking-wider block mb-0.5">Important Note</span>
                                            {package_popup?.notes}
                                        </p>
                                    </div>
                                </div>
                            )}

                            {/* Procedure Section */}
                            {package_popup?.procedure_involved && (
                                <div className="pt-2">
                                    <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-2">Procedure Involved</h4>
                                    <div className="sub__title text-gray-700 text-sm leading-relaxed" dangerouslySetInnerHTML={{ __html: package_popup?.procedure_involved }} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
            {/* {package_popup && (
                    <div className='absolute top-10 left-32 z-30 shadow-xl bg-white shadow-red-900/10 overflow-hidden rounded'>

                        <div className={`relative `}>

                            <div className='bg-blue-100 '>
                                <button
                                    onClick={close_Package_Popup}
                                    className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
                                >
                                    X
                                </button>
                                <svg className='w-full' height="122" viewBox="0 0 534 122" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 97.5001V0H533.333V97.5001C488.889 65.4241 444.444 65.4241 400 97.5001C355.556 129.576 311.111 129.576 266.667 97.5001C222.222 65.4241 177.778 65.4241 133.333 97.5001C88.8889 129.576 44.4444 129.576 0 97.5001Z" fill="#DBEAFE"
                                    />
                                </svg>
                            </div>
                            <div className='relative text-center p-4 z-20'>
                                <div className='text-gray-800 font-semibold text-sm'>{package_popup?.name}</div>
                                <h3 className='text-gray-900 font-bold text-lg'>₹ {package_popup?.amount}</h3>
                            </div>
                        </div>
                        <div className='p-4 mt-4'>
                            <ul className='text-[12px]/8 text-gray-900 font-medium'>
                                {package_popup?.packages?.length > 0 && package_popup?.packages?.map((list_item) => (
                                    <li>
                                        {list_item?.is_included ? (<i class="gicon bg-green-100 mr-2 gi-check rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-green-700" aria-hidden="true"></i>) : (<i class="gicon bg-gray-200 mr-2 gi-close rounded-full text-center py-1 w-[20px] h-[20px] text-[10px] font-black text-gray-900" aria-hidden="true"></i>)}
                                        {list_item?.item_name}</li>
                                ))}



                            </ul>
                           

                        </div>
                    </div>
                )} */}
            <div className={`fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 ${isModalOpen ? 'block' : 'hidden'}`}>
                <div className="bg-white p-6 rounded-2xl shadow-lg w-96">
                    <h2 className="text-lg font-semibold mb-4">Cancel Pooja</h2>

                    <textarea
                        className="w-full border border-gray-300 rounded-md p-2 mb-3"
                        rows="3"
                        placeholder="Enter your reason for cancellation"
                        value={customReason}
                        onChange={(e) => {
                            const value = e.target.value;
                            // Allow only letters, numbers, and spaces
                            const filteredValue = value.replace(/[^a-zA-Z0-9 ]/g, "");
                            setCustomReason(filteredValue);
                        }}
                    />

                    <div className="flex justify-end gap-2">
                        <button
                            onClick={handleCloseModal}
                            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
                        >
                            Leave
                        </button>
                        <button
                            disabled={!customReason || !setSelectedPoojaId || cancelLoading}
                            onClick={handleConfirmCancelPooja}
                            className={`px-4 py-2 text-white rounded-md ${customReason ? "bg-red-600" : 'bg-red-400'} `}
                        >
                            {cancelLoading ? "Cancelling..." : "Cancel"}
                        </button>
                    </div>
                </div>
            </div>
            {isInvoiceOpen && selectedInvoice && (() => {
                const invoice = {
                    orderNo: selectedInvoice?.orderNo,
                    date: selectedInvoice?.created_at?.slice(0, 10),
                    location: selectedInvoice?.location,
                    poojapackage: selectedInvoice?.poojapackage?.name,
                    description: selectedInvoice?.title,
                    paymentmethod: selectedInvoice?.paymentmethod,
                    paymentstatus: selectedInvoice?.payment_status || selectedInvoice?.paymentstatus,
                    numberofpandit: selectedInvoice?.poojapackage?.number_of_pandit,
                    numberofday: selectedInvoice?.poojapackage?.number_of_day,
                    duration: selectedInvoice?.poojapackage?.duration,
                    total: Number(selectedInvoice?.price || 0),
                    poojadate: selectedInvoice?.pooja_date,
                    poojatime: selectedInvoice?.from_time,
                    panditName: selectedInvoice?.astro?.name || selectedInvoice?.panditName,
                    bookingStatus: selectedInvoice?.status === 1 ? "Pending" : selectedInvoice?.status === 2 ? "Processing" : selectedInvoice?.status === 3 ? "Complete" : "Canceled",
                };

                const downloadInvoicePDF = async () => {
                    const input = invoiceRef.current;
                    const canvas = await html2canvas(input, { scale: 2 });
                    const imgData = canvas.toDataURL("image/png");
                    const pdf = new jsPDF("p", "mm", "a4");
                    const width = pdf.internal.pageSize.getWidth();
                    const height = (canvas.height * width) / canvas.width;
                    pdf.addImage(imgData, "PNG", 0, 0, width, height);
                    pdf.save(`Invoice-${invoice.orderNo}.pdf`);
                };

                return (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4 overflow-y-auto">
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col relative transition-all overflow-hidden">
                            {/* Modal Header */}
                            <div className="flex justify-between items-center px-6 py-4 bg-gray-50 border-b shrink-0">
                                <h3 className="font-bold text-lg text-gray-800">Invoice Details</h3>
                                <button
                                    onClick={() => {
                                        setIsInvoiceOpen(false);
                                        setSelectedInvoice(null);
                                    }}
                                    className="text-gray-500 hover:text-gray-800 text-2xl font-bold focus:outline-none"
                                >
                                    &times;
                                </button>
                            </div>

                            {/* Modal Content - Scrollable */}
                            <div className="p-6 overflow-y-auto flex-1">
                                <div
                                    ref={invoiceRef}
                                    className="bg-white p-6 sm:p-10 text-gray-800 border border-gray-100 rounded-xl"
                                >
                                    {/* Header */}
                                    <div className="flex justify-between items-start border-b pb-6 flex-wrap gap-4">
                                        <div className="flex items-center gap-4">
                                            {settingData && settingData[0]?.header_logo ? (
                                                <img
                                                    src={`${IMG_BASE_URL}${settingData[0].header_logo}`}
                                                    alt="Company Logo"
                                                    className="h-12 object-contain"
                                                />
                                            ) : (
                                                <h2 className="text-2xl font-bold text-[#9F2225]">Omens</h2>
                                            )}
                                        </div>

                                        <div className="text-right text-sm space-y-1">
                                            <p>
                                                <b className="text-gray-500">Order No:</b> <span className="font-semibold text-gray-900">{invoice.orderNo}</span>
                                            </p>
                                            <p>
                                                <b className="text-gray-500">Invoice Date:</b> <span className="font-semibold text-gray-900">{invoice.date}</span>
                                            </p>
                                            <p>
                                                <b className="text-gray-500">Payment Status:</b>{" "}
                                                <span className={`px-2 py-0.5 rounded text-xs font-bold uppercase ${invoice.paymentstatus?.toLowerCase() === 'paid' || invoice.paymentstatus?.toLowerCase() === 'success'
                                                    ? 'bg-green-100 text-green-800'
                                                    : 'bg-yellow-100 text-yellow-800'
                                                    }`}>
                                                    {invoice.paymentstatus || "Pending"}
                                                </span>
                                            </p>
                                        </div>
                                    </div>

                                    <div className="mt-4">
                                        <h1 className="text-2xl font-extrabold tracking-tight text-gray-900">Pooja Invoice</h1>
                                    </div>

                                    {/* Details Section */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6 text-sm">
                                        {/* Left Column */}
                                        <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 space-y-3">
                                            <h3 className="font-bold text-gray-900 border-b pb-2 text-base flex items-center gap-2">
                                                <span className="w-2.5 h-2.5 rounded-full bg-[#9F2225]"></span>
                                                Pooja & Package Info
                                            </h3>
                                            <div className="space-y-2">
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">Pooja Name:</span>
                                                    <span className="font-semibold text-gray-950 text-right">{invoice.description}</span>
                                                </p>
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">Package Details:</span>
                                                    <span className="font-semibold text-gray-950 text-right">{invoice.poojapackage}</span>
                                                </p>
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">Duration:</span>
                                                    <span className="font-semibold text-gray-950 text-right">{invoice.duration || "N/A"}</span>
                                                </p>
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">Location:</span>
                                                    <span className="font-semibold text-gray-950 text-right">{invoice.location || "N/A"}</span>
                                                </p>
                                            </div>
                                        </div>

                                        {/* Right Column */}
                                        <div className="bg-gray-50 rounded-xl p-5 border border-gray-100 space-y-3">
                                            <h3 className="font-bold text-gray-900 border-b pb-2 text-base flex items-center gap-2">
                                                <span className="w-2.5 h-2.5 rounded-full bg-[#9F2225]"></span>
                                                Pandit & Schedule Info
                                            </h3>
                                            <div className="space-y-2">
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">Pandit Name:</span>
                                                    <span className="font-semibold text-gray-950 text-right">{invoice.panditName || "Not Assigned"}</span>
                                                </p>
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">Pooja Date & Time:</span>
                                                    <span className="font-semibold text-gray-950 text-right">
                                                        {invoice.poojadate} {invoice.poojatime ? `at ${formatTime(invoice.poojatime)}` : ""}
                                                    </span>
                                                </p>
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">No. of Pandits:</span>
                                                    <span className="font-semibold text-gray-950 text-right">{invoice.numberofpandit || 1}</span>
                                                </p>
                                                <p className="flex justify-between gap-4">
                                                    <span className="text-gray-500">No. of Days:</span>
                                                    <span className="font-semibold text-gray-950 text-right">{invoice.numberofday || 1}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Table */}
                                    <div className="mt-6 overflow-x-auto">
                                        <table className="w-full border border-collapse rounded-lg overflow-hidden text-sm">
                                            <thead className="bg-gray-100 border-b">
                                                <tr>
                                                    <th className="p-3 text-left font-semibold text-gray-700">Pooja Name / Description</th>
                                                    <th className="p-3 text-center font-semibold text-gray-700">Pooja Date</th>
                                                    <th className="p-3 text-right font-semibold text-gray-700">Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className="border-b hover:bg-gray-50/50">
                                                    <td className="p-3">
                                                        <p className="font-semibold text-gray-900">{invoice.description}</p>
                                                        <p className="text-xs text-gray-500 mt-0.5">Package: {invoice.poojapackage}</p>
                                                    </td>
                                                    <td className="p-3 text-center text-gray-800">{invoice.poojadate}</td>
                                                    <td className="p-3 text-right font-semibold text-gray-900">₹{invoice.total}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Summary */}
                                    <div className="flex justify-end mt-4">
                                        <div className="w-80 space-y-2 text-sm">
                                            <div className="flex justify-between text-gray-600">
                                                <span>Subtotal</span>
                                                <span className="font-medium text-gray-900">₹{invoice.total}</span>
                                            </div>
                                            <div className="border-t pt-2 flex justify-between font-bold text-lg text-gray-900">
                                                <span>Total</span>
                                                <span>₹{invoice.total}</span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Note */}
                                    <div className="mt-6 bg-gray-50 p-4 rounded border border-gray-100 text-sm">
                                        <p className="font-semibold text-gray-950">Note</p>
                                        <p className="text-gray-600 mt-1">Thank you for booking your pooja with us. If you have any questions, please contact our support team.</p>
                                    </div>
                                </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="flex justify-end gap-2 px-6 py-4 bg-gray-50 border-t shrink-0">
                                <button
                                    onClick={downloadInvoicePDF}
                                    className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition"
                                >
                                    <FaFilePdf /> Download PDF
                                </button>
                                <button
                                    onClick={() => {
                                        setIsInvoiceOpen(false);
                                        setSelectedInvoice(null);
                                    }}
                                    className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2 rounded-lg text-sm font-semibold transition"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}
        </div>
    )
}

export default User_Dashboard_My_Pooja_List